<template>
<div class="page-guide _brand">

    <h1 class="heading_section-title">
        <p class="main">FAQ</p>
        <span>よくある質問</span>
    </h1>

    <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::
        GUIDE
    :::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
    <section class="faq">
        <div class="inner">


        <h3 class="heading">AUMAについて</h3>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>AUMAとはなんですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        AUMAはハイセンスなクリエイターとバイヤーが集まり繋がることができるBtoB情報検索サービスです。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>他社プラットフォームとの違いは何ですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        AUMAは、売り手企業様と買い手企業様の出会いの場の提供をサポートするBtoBの検索プラットフォームです。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>どんな人が会員登録できますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        AUMAは、法人・個人事業主の方が会員登録できます。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>AUMAの推奨環境はなんですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        以下のブラウザでのご利用を推奨しております。<br>
                        推奨環境以外で御覧いただいた場合、本サイトのデザインと異なった表示をしてしまったり、一部の機能が使えない可能性がございます。<br>
                        <br>
                        対応OS / 推奨ブラウザ<br>
                        1. パソコン<br>
                        Microsoft Edge最新バージョン<br>
                        Google Chrome最新バージョン<br>
                        Safari最新バージョン<br><br>
                        2. スマートフォン<br>
                        Android6以降（Google Chrome最新バージョン）<br>
                        ※一部対応していない端末がございます<br>
                        iOS最新バージョン（Safari最新バージョン）<br>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>AUMAを利用するために費用はかかりますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        ショップ・ブランド・ショールームのページを開設にあたりまして、
                        プランによっては無料のフリープランと情報の記載が豊富でAUMA内でコミュニケーションがとれ、マッチングに近づける有料のベーシックプラン（サブスプリクション）があります。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>他社の情報は見れますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        ・ブランド→ブランド<br>
                        有料・無料にかかわらずご覧頂ける情報は一般の方と同じです。<br><br>
                        ・ショップ→ショップ<br>
                        ご覧いただけません<br><br>
                        ・ショールーム→ショールーム<br>
                        ご覧頂ける情報は一般の方と同じです。
                        </div>

                    </div>
                </div>
            </div>


            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>価格軸とはなんですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        アイテムを基準とし、平均額から算出した3つの価格基準となります。
                        </div>

                    </div>
                </div>
            </div>


            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>一般のユーザーも掲載情報を見れますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        ブランドイメージ写真（2枚）・コンセプト・カテゴリー平均プライスはご覧頂けます。<br>
                        ※トップニュース・セールス募集・セールススタイル・卸値等は登録事業者様のみご覧になれます。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>スマートフォンでも登録やり取りはできますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        スマートフォン・タブレットにも対応致しております。<br>
                        ブランド情報の確認やいつでもどこでも対応できるのでストレス無くご利用頂けます。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>AUMAの利用において禁止行為はありますか</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        サービスの利用において、以下に該当する行為またはその恐れがある行為を禁止しております。当社が禁止行為を確認した場合には、非公開措置等をおこなわせていただくこともございますのでご了承ください。<br>
                        また、利用規約やプライバシーポリシーも合わせてご確認ください。<br>
                        1.法令または公序良俗に違反する行為<br>
                        2.犯罪行為に関連する行為<br>
                        3.当社，本サービスの他のユーザー，または第三者のサーバーまたはネットワークの機能を破壊したり，妨害したりする行為<br>
                        4.当社のサービスの運営を妨害するおそれのある行為<br>
                        5.他のユーザーに関する個人情報等を収集または蓄積する行為<br>
                        6.不正アクセスをし，またはこれを試みる行為<br>
                        7.他のユーザーに成りすます行為<br>
                        8.当社のサービスに関連して，反社会的勢力に対して直接または間接に利益を供与する行為<br>
                        9.当社，本サービスの他のユーザーまたは第三者の知的財産権，肖像権，プライバシー，名誉その他の権利または利益を侵害する行為<br>
                        10.以下の表現を含み，または含むと当社が判断する内容を本サービス上に投稿し，または送信する行為<br><br>
                        0.過度に暴力的な表現<br>
                        1.露骨な性的表現<br>
                        2.人種，国籍，信条，性別，社会的身分，門地等による差別につながる表現<br>
                        3.自殺，自傷行為，薬物乱用を誘引または助長する表現<br>
                        4.その他反社会的な内容を含み他人に不快感を与える表現<br>
                        11.以下を目的とし，または目的とすると当社が判断する行為<br><br>
                        0.営業，宣伝，広告，勧誘，その他営利を目的とする行為（当社の
                        認めたものを除きます。）<br>
                        1.性行為やわいせつな行為を目的とする行為<br>
                        2.面識のない異性との出会いや交際を目的とする行為<br>
                        3.他のユーザーに対する嫌がらせや誹謗中傷を目的とする行為<br>
                        4.当社，本サービスの他のユーザー，または第三者に不利益，損害
                        または不快感を与えることを目的とする行為<br>
                        5.その他本サービスが予定している利用目的と異なる目的で本サー
                        ビスを利用する行為<br>
                        12.宗教活動または宗教団体への勧誘行為<br>
                        13.その他，当社が不適切と判断する行為<br>
                        第6条（本サービスの提供の停止等）<br><br>
                        1.当社は，以下のいずれかの事由があると判断した場合，ユーザーに事前に通知することなく本サービスの全部または一部の提供を停止または中断することができるものとします。<br>
                        0.本サービスにかかるコンピュータシステムの保守点検または更新を行う場合<br>
                        1.地震，落雷，火災，停電または天災などの不可抗力により，本サービスの提供が困難となった場合<br>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>取引希望者との連絡はどのように取りますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        原則として、取引に関する連絡はDM機能やメッセージを使って直接行なっていただきます。<br>
                        AUMAは取引に介入いたしませんので、あらかじめご了承ください。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>AUMAから電話がかかってくることはありますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        カスタマーサポート用の電話番号はございませんので、お電話でのサポートは行っておりませんが、<br>
                        ショップの運営状況などを確認させていただくために、AUMAの担当者よりお電話をすることがございます。<br>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>「AUMA」の機能について意見や要望を送ることはできますか</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        お問い合わせフォームやメールにてサポートを行っております。<br>
                        それぞれの対応時間帯は以下です。<br><br>
                        ＜お問い合わせメール＞<br>
                        <a href="mailto:support@AUMA.jp?subject=【AUMAサポート】問い合わせ&amp;body=ご記入ください">support@AUMA.jp</a><br>
                        平日 10:30～19:00<br>
                        ※いただきましたお問い合わせには、順番に回答しております。<br>
                        ※非常に多数のお問い合わせをいただいており、現在【３〜５営業日】ほどでのご返信となっております。<br><br>
                        お手数おかけいたしますが、お問い合わせはメールよりご連絡ください。<br><br>
                        なお、電話でのサポートは行っておりません。
                        </div>

                    </div>
                </div>
            </div>


<!-- AUMAについてのFaq End ------------------------------------>

<!-- 登録についてのFaq Start ------------------------------------>
        <h3 class="heading ">登録について</h3>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>初回登録時にNEXTボタンが非活性で次に進めません。</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        電話番号にハイフンが入っている、または記入漏れがある場合があるので再度記入欄をご確認ください。
                        </div>

                    </div>
                </div>
            </div>


            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>個別のページカスタマイズにも答えて頂けますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            現時点ではカスタマイズは行なっておりません。<br>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>写真は何枚載せられますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            ・ブランド（BASICプランの場合）<br>
                            ブランドイメージ写真6枚＋プライスレンジ写真10枚が掲載可能です。<br>
                            フリープランは2枚となります。(5MB以下でのサイズとなります。）<br><br>
                            ・ショップ（PERSINAL・UNIT)<br>
                            ショップ写真2枚（店舗・イメージ写真）<br><br>
                            ・ショールーム（BASICプランのみ）<br>
                            ショールームイメージ写真6枚（ショールーム写真・ブランドイメージ写真）<br>
                        </div>

                    </div>
                </div>
            </div>


            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>本登録用URLのメールが届かない場合はどうすればよいですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        24時間経っても本登録用URLが届かない場合には、恐れ入りますが事務局までお問い合わせください。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>登録を最後まで終えずにやめてしまいましたがどうしたら良いでしょうか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        会員情報の登録が未完了のままでブラウザを閉じた場合には、登録内容は保存されません。恐れ入りますが、再度初めからご入力をお願いいたします。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>パスワードを忘れました</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        ログイン画面からパスワードの再発行依頼をお願いいたします。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>登録IDを忘れました</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        お客様のメールアドレスがログインIDとなります。お忘れの場合には事務局までお問い合わせください。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>18歳未満（未成年）でも登録は可能ですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        事業者でありAUMA内でのフィルターの承認をとる事ができれば、18歳未満の方でもご利用いただけます。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>運営に関するガイドラインはありますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        本サービスは、ユーザーに取引の「場」を提供するものです。<br>
                        ユーザーが本サービスを通して行う「取引」（情報の閲覧、情報パートナーとの取引等）との間で直接行っていただくものです。<br>
                        当社は、取引の当事者とはならず、取引に関する責任は負いません。<br>
                        したがって、万一取引に関してトラブルが生じた際には、ユーザーとサービス提供者との間で直接解決していただくことになります。<br><br>

                        上記運営ガイドラインを遵守いただけない場合、特定商取引法に基づく表記の不備があった場合、商品取引に関するトラブルに速やかに対応いただけない場合などは、利用規約に基づきショップ運営停止（非公開・振込申請停止等）をおこなうことがございますので、ご注意ください。<br><br>

                        詳しくは各利用規約をご参照ください。<br>
                        <a v-bind:href="route('brand.rule')" target="_blank" class="md_text-link"><span>・ブランド利用規約</span></a><br>
                        <a v-bind:href="route('shop.rule')" target="_blank" class="md_text-link"><span>・ショップ利用規約</span></a><br>
                        <a v-bind:href="route('showroom.rule')" target="_blank" class="md_text-link"><span>・ショールーム利用規約</span></a>
                        </div>

                    </div>
                </div>
            </div>


            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>個人での登録はできますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        ショップのパーソナルアカウント（個人利用のみ登録が出来ます）<br>
                        主にこれからショップ運営を考えられている方または、制作のの事業に関わっていきたい方などが対象です。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>ショップ・ブランド・ショールーム開設（新規アカウント登録）はどこから可能ですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        <a href="/registration" class="md_text-link" target="_blank"><span>無料会員登録</span></a>より新規アカウント登録をしていただくことができます。<br>
                        複数ブランドと複数ショップの開設をご希望される場合、1件ごとにアカウントが必要となります。<br>
                        １つのアカウントで複数のショップを運営いただくことはできませんのでご注意ください。<br>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>認証メールが届かないときはどうすればいいですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        アカウントを作成すると、info@AUMA.jpより認証メールをお送りします。<br>
                        件名：AUMAへのご登録ありがとうございます<br><br>
                        メールが届かない場合は、迷惑メールBOXやSpamメール・受信先が複数ある場合は受信先のメールBOXの確認も行なって下さい。<br><br>
                        info@AUMA.jpからのメールを受け取れる設定にし、メールを再送してください。<br>
                        登録時にメールアドレスを打ち間違えてしまった場合は、再度登録手続きを行ってください。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>複数ブランドまたは複数ショップを作成することはできますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        複数のブランドと複数のショップを作成したい場合は、複数のメールアドレスを用意いただき、それぞれのメールアドレスでショップを作成してください。<br>
                        ※1つのメールアドレスで複数のブランドと複数のショップを作成いただくことはできません。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>自分の登録ページはどのようにして確認しますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            画面右上にあるマイセレクトルーム（家のマーク）を押して頂くと、管理画面が表示されます。<br><br>
                            ショップの場合shopを選択するとショップ一覧ページへ、ショップ名をクリックすると編集と確認が行えます。<br><br>
                            ブランドの場合Brandを選択するとブランド一覧ページへ、ブランド名をクリックすると編集と確認が行えます。<br><br>
                            ショールームの場合Showroomを選択するとショールーム一覧ページへ、ショールーム名をクリックすると編集と確認が行えます。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>どうやってメールアドレスを変更できますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        管理画面のSetting（個人設定）のユーザー情報にて変更できます。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>どうやってパスワードを変更できますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        管理画面のSetting（個人設定）のパスワード設定にて変更できます。<br><br>
                        ※ご利用のメールアドレスに再設定用URLの記載されたメールを送信いたします。URLをクリックしてパスワードを再設定してください。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>ショップ設定やユーザ情報の変更はどこから可能ですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        ショップの設定やユーザー情報の設定は管理画面で行えます。<br><br>
                        画面右上にあるマイセレクトルーム（家のマーク）を押して頂くと、管理画面が表示されます。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>Price rangeに登録できる商品数やデータ容量はありますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            登録できる商品数は10枚・5MB以下でのサイズとなります。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>Price rangeに登録した商品を全削除することはできますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            全ての商品を一括で削除する機能はご用意しておりません。<br>
                            商品ごとに削除を行なって下さい。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>Price rangeに登録できる商品画像に動画を登録することはできますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            動画を登録することはできません。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>Price rangeに登録できる商品をSOLD OUT表記にするにはどうしたらいいですか</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            詳細ページのPrice rangeにて在庫の有無の隣にあるチェックボックスをチェックで在庫あり、チェックを外すとSOLD OUT表記になります。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>Price rangeに登録できる商品を非表示にできますか</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            表示・非表示の機能はございません。<br>
                            表示しない場合は画像の削除をお願いします。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>詳細ページの画像に推奨サイズはありますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            大変恐れ入りますが、画像・ショップのロゴ画像は適切なサイズを設けておりません。<br>
                            5MB以下の画像でお試しいただき、アップロード後にご確認いただきますようお願いいたします。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>事業者の氏名、所在地、連絡先は変更・修正できますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            管理画面のsettingより行って下さい。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>AUMAからのメールが届かないときはどうしたらいいですか</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            AUMAより自動送信しておりますメール（認証メールなど）や、サポートからのご案内・返信メールが届かない場合には、以下の点をご確認ください。<br>
                            ■ GmailやYahoo!メールなどのフリーメールアドレスをご利用の場合<br>
                            迷惑メールフォルダやその他のフォルダに自動振り分けされてしまっていることがございます。<br>
                            「AUMA」でメールフォルダの検索を行っていただくようお願いいたします。<br><br>
                            ■携帯電話のメールアドレスをご利用の場合<br>
                            キャリアが提供している迷惑メールフィルタ機能により、AUMAから送信したメールが自動的に受信拒否されている可能性があります。<br>
                            info@AUMA.jpおよび support@AUMA.jpをメールアドレス指定受信、もしくは、AUMA.jpドメイン指定受信に設定いただくようお願いします。<br>
                            各キャリアごとの指定受信設定方法は以下の通りです。<br><br>
                            <a href="https://www.docomo.ne.jp/info/spam_mail/domain/" class="md_text-link" target="_blank"><span>docomo 指定受信／拒否設定 （外部サイト）</span></a><br>
                            <a href="https://www.au.com/support/service/mobile/trouble/mail/email/filter/detail/domain/" class="md_text-link" target="_blank"><span>au 受信リスト設定 （外部サイト）</span></a><br>
                            <a href="https://www.softbank.jp/mobile/support/mail/antispam/mms/whiteblack/" class="md_text-link" target="_blank"><span>SoftBank 迷惑メールの受信許可・拒否設定をする（外部サイト）</span></a><br>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>一時休止・休業中のお知らせは掲載できますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        登録ページの編集にてお願いします。<br><br>
                        画面右上にあるマイセレクトルーム（家のマーク）を押して頂くと、管理画面が表示されます。<br><br>
                        ショップの場合shopを選択するとショップ一覧ページへ、ショップ名をクリックすると編集と確認が行えます。<br><br>
                        ブランドの場合Brandを選択するとブランド一覧ページへ、ブランド名をクリックすると編集と確認が行えます。<br><br>
                        ショールームの場合Showroomを選択するとショールーム一覧ページへ、ショールーム名をクリックすると編集と確認が行えます。<br><br>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>ベーシックプラン契約中に、AUMAを退会することはできますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        ベーシックプラン契約中は、AUMAから退会することができません。<br>
                        ベーシックプランからフリープランに変更し、管理画面よりプランにてフリープランである状態を確認後、退会することができます。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>退会するにはどうしたらいいでしょうか</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            管理画面より退会のお手続きをお願いいたします。<br><br>
                            ■ パスワードが分からず、退会ページにログインできない場合<br>
                            <a href="/forgot-password" class="md_text-link" target="_blank"><span>パスワードリセットページ</span></a>よりパスワードの再設定を行っていただけます。<br><br>
                            ■ メールアドレスが不明または使えず、退会ページにログインできない場合<br>
                            こちらのヘルプページの「メールアドレスが不明または使えないためパスワードリセットができない場合」をご確認の上、必要事項をご連絡ください。<br><br>
                            ■ スタッフの方がショップへの参加を解除したり、スタッフアカウントの削除をしたい場合<br>
                            ショップへの参加を解除したい場合は、管理画面の【ユーザー情報】から退会することができます。
                        </div>
                    </div>
                </div>
            </div>

<!-- 登録についてEnd ------------------------------------>

<!-- 料金プランについてStart ------------------------------------>
        <h3 class="heading ">料金プランについて</h3>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>料金体系や導入に必要なこと、機能についての詳しい詳細はありますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        AUMAについてとご利用ガイドをご覧下さい。<br><br>
                        AUMAについて（料金プラン）<br>
                                    <a v-bind:href="route('brand.about')" class="md_text-link" target="_blank"><span>・ブランド様用</span></a><br>
                                    <a v-bind:href="route('shop.about')" class="md_text-link" target="_blank"><span>・ショップ様用</span></a><br>
                                    <a v-bind:href="route('showroom.about')" class="md_text-link" target="_blank"><span>・ショールーム様用</span></a><br><br>
                        ご利用ガイド<br>
                                    <a v-bind:href="route('brand.guide')" class="md_text-link" target="_blank"><span>・ブランド様用</span></a><br>
                                    <a v-bind:href="route('shop.guide')" class="md_text-link" target="_blank"><span>・ショップ様用</span></a><br>
                                    <a v-bind:href="route('showroom.guide')" class="md_text-link" target="_blank"><span>・ショールーム様用</span></a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>お互い取引をする場合に手数料などは発生しますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            手数料などは一切発生いたしません。<br>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>どのような支払方法がありますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            月額プランは、クレジットカード決済のみ（サブスクリプション）となっております。<br>銀行振り込みや口座引き落としは対応しておりません。予めご了承ください。
                        </div>

                    </div>
                </div>
            </div>


            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>サービス利用料とはなんですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            ショップのパーソナルアカウント（個人利用）・ユニットアカウント（法人利用）・ブランドのフリープランは無料で登録いただけます。<br>
                            ブランドのベーシックプラン・ショールームのベーシックプランはサービス利用料が異なります。<br>
                            各プランごとの詳細な費用に関しては、AUMAについてよりご確認ください。<br><br>
                            AUMAについて（料金プラン）<br>
                            <a v-bind:href="route('brand.about')" class="md_text-link" target="_blank"><span>・ブランド様用</span></a><br>
                            <a v-bind:href="route('shop.about')" class="md_text-link" target="_blank"><span>・ショップ様用</span></a><br>
                            <a v-bind:href="route('showroom.about')" class="md_text-link" target="_blank"><span>・ショールーム様用</span></a><br><br>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>プランとは何がありますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        AUMAの料金プランは、ショップ・ブランド・ショールームの３つの登録先により変わります。<br>
                        詳しくはAUMAについて（料金プラン）をご参照ください。
                        AUMAについて（料金プラン）<br>
                            <a v-bind:href="route('brand.about')" class="md_text-link" target="_blank"><span>・ブランド様用</span></a><br>
                            <a v-bind:href="route('shop.about')" class="md_text-link" target="_blank"><span>・ショップ様用</span></a><br>
                            <a v-bind:href="route('showroom.about')" class="md_text-link" target="_blank"><span>・ショールーム様用</span></a><br><br>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>どうすればベーシックプランにアップグレードできますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        無料登録をしたのちに、管理画面より（Brand）を選択し、プランをFREEからBASICへアップグレードさせサブスクリプションのお申し込みをするとベーシックプランへアップグレード出来ます。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>ベーシックプランの月額サービス料金は、税込ですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        ブランドベーシックプランの月額サービス料金は、税込で月額4,950円<br>
                        ショールームのベーシックプランの月額サービス料金は、税込で月額11,000円となります。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>ベーシックプランの契約期間は、いつからいつまでですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        1ヶ月ごとのサブスクリプション契約となります。<br>
                        支払い日が翌月に同じ日が存在しない場合は自動的にその前の日が更新日となります。(8月31日の場合、9月30日)
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>ベーシックプランの更新は、どのようにできますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        プランに記載されている次回請求日に、ご登録のクレジットカードに対して自動的に決済処理をおこないます。更新手続きをしていただく必要はございません<br><br>
                        例）4/18 15:00にベーシックプランを契約した場合<br>
                        次回請求日である5/19 深夜0時ごろに、自動的に決済処理をおこないます｡
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>ベーシックプランの引き落とし元クレジットカードは、変更できますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        管理画面のプラン選択より下部の「プランの変更またはキャンセル」より変更できます。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>ベーシックプランの引き落としが失敗したら、どうすればいいですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        ベーシックプランの引き落とし日に決済が失敗した場合、ご登録のメールアドレスにお知らせメールをお送りいたします。メールが届きましたら、利用可能なカード情報に変更してください。<br>
                        猶予期間までに有効なクレジットカードを登録し、再決済処理が完了すると、フリープランに変更されることなく、元々の請求日から起算してベーシックプランを更新することができます。
                        </div>
                        <div class="nest-item">
                        例）4/18 15:00にベーシックプランを契約したが、契約更新に失敗。その後、猶予期間以内に有効なクレジットカードで契約更新を完了した場合<br><br>
                        ・ベーシックプランの契約期間<br>
                        4/18 15:00〜5/18 23:59<br>
                        ・ベーシックプランの更新タイミング<br>
                        5/19 深夜0時ごろ、登録したクレジットカードへの決済処理をおこなうが、決済に失敗<br><br>
                        ・有効なクレジットカードでの契約更新のタイミング<br>
                        5/25 に決済を完了し、猶予期間である5/19〜6/1（14日間）以内に契約更新を完了<br><br>
                        ・更新されたベーシックプランの契約期間と次回更新日<br>
                        契約期間：5/19〜6/19 23:59<br>
                        次回更新日：6/20 深夜0時ごろ
                        </div>
                        <div class="nest-item">
                        例）4/18 15:00にベーシックプランを契約したが、契約更新に失敗。その後、猶予期間以内に再決済処理がおこなえなかった場合<br><br>
                        ・ベーシックプランの契約期間<br>
                        4/18 15:00〜5/18 23:59<br><br>

                        ・ベーシックプランの更新タイミング<br>
                        5/19 深夜0時ごろ、登録したクレジットカードへの決済処理をおこなうが、決済に失敗<br>

                        ・有効なクレジットカードでの契約更新のタイミング<br>
                        猶予期間である5/19〜6/1（14日間）以内に、有効なクレジットカードを登録できておらず、決済に失敗<br>

                        ・フリープランに自動的に変更されるタイミング<br>
                        6/2 深夜0時ごろよりスタンダードプランに変更
                        </div>
                        <div class="nest-item">
                        ※決済失敗理由の一例：<br>
                        カードの利用限度額に達している<br>
                        カードの有効期限が切れている<br>
                        カードの有効期限更新後、管理画面で有効期限の変更をおこなっていない<br>
                        その他の理由、くわしい理由については、ご利用のカード会社へおたずねください。<br><br>


                        ■ 別のクレジットカードへ変更する場合<br>
                        現在登録しているカードとは別のカードに変更した場合には、すぐに決済がおこなわれます。<br><br>

                        決済が完了したタイミングで、ベーシックプランが更新されます。<br><br>
                        ■ 同じクレジットカードで再決済する場合<br>
                        再決済は、元々の請求日から起算して14日目まで、決済が成功するまで毎日深夜0時ごろに自動的におこなわれます。<br>
                        再決済完了したタイミング（「【AUMA】ベーシックプランの自動更新が完了しました」という件名のメールが届きます）で、ベーシックプランが更新されます。<br>
                        14日目の再決済処理でも決済完了できなかった場合、自動的にフリープランに変更となります。<br>
                        ベーシックプランを再度ご利用されたい場合は、管理画面のプラン選択よりあらためてベーシックプランの契約をおこなってください。
                        </div>

                    </div>
                </div>
            </div>


            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>ベーシックプラン契約後すぐにフリープランへ変更した場合、月額料金の返金はされますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        契約後すぐにフリープランに変更しても、月額料金の返金はおこなっておりません。<br>
                        日割り計算などによる返金もいたしかねますので、ご了承ください。<br><br>
                        ただし、ご変更手続きをおこなった時点で、すぐにプランが切り替わるものではありません。<br>
                        べーシックプランの月額課金がおこなわれてから【1ヶ月】は、ベーシックプランが適用される期間となります。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>月によってプランを使いわけられますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        フリープランとベーシックプランは、いつでも相互にプラン変更をおこなうことができますが、切り替わるタイミングは、以下のように異なります。<br><br>
                        例）フリープランからベーシックプランに変更の場合<br>
                        ベーシックプランの決済完了後、即時にベーシックプランへ切り替わります。<br><br>
                        例）ベーシックプランからフリープランに変更の場合<br>
                        フリープランへの変更手続き後、即時にプランが切り替わるのではなく、すでに契約しているベーシックプランの契約期間終了後に、自動的にフリープランに切り替わります。<br>
                        契約期間終了後、自動的にフリープランに変更されます。
                        </div>

                    </div>
                </div>
            </div>



<!-- 料金プランについてEnd ------------------------------------>

<!-- 管理画面についてStart ------------------------------------>
        <h3 class="heading ">管理画面について</h3>


            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>My Select Room とはなんですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                            お気に入りアクション機能です。<br>
                            ショップがビジネス対象のリストを確認でき、チャットトークや展示会情報が確認できる機能となります。
                        </div>

                    </div>
                </div>
            </div>


            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>気になるブランドとやり取りを行いたいのですがどうしたらいいですか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                    My Select Roomに気になるブランドを入れるとAUMAトーク（チャット機能）が使用可能になります。<br>
                    （PERSINALプラン・UNITプランの登録が必要です）
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>ログインは、どこから可能ですか？（スーパー管理者）</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        登録後、メールでお送りしているログインURLからログインしていただくことが可能です。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>ログインは、どこから可能ですか？（管理者）</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        登録後、メールでお送りしているログインURLからログインしていただくことが可能です。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>ログアウトはどこからできますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        監理画面の左下Logoutよりログアウトできます
                        </div>

                    </div>
                </div>
            </div>


            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>メールアドレス・パスワードの変更はどこからできますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        メールアドレス変更は管理画面のSetting（個人設定）のユーザー情報にて変更できます。<br><br>
                        パスワードの変更は管理画面のSetting（個人設定）のパスワード設定にて変更できます。<br>
                        ※ご利用のメールアドレスに再設定用URLの記載されたメールを送信いたします。URLをクリックしてパスワードを再設定してください。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>複数人にログイン権限を付与できますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        スーパー管理者でログイン後、管理画面のSetting（会社設定）にて管理者に権限を付与できます。
                        </div>

                    </div>
                </div>
            </div>


            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>アプローチDMでの配信とはなんですか</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        ブランドは任意でショップ・ショールームに対しブランド情報や展示会情報などを自動配信する事が出来ます。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>一日に配信できるDMの上限数などはありますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        一日に配信できる上限数などはありませんが、頻繁に送られてしまいますと、フォロワーの皆さまにご迷惑をかけることがございます。<br><br>
                        効果的に販売促進をしていただくためにも、配信数や内容につきましては、ブランドにて再考いただき、プッシュ通知をご利用いただければと思います。
                        </div>

                    </div>
                </div>
            </div>

            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>アプローチDMでの配信はどうやって登録しますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        ブランド管理者で管理画面にログイン後、管理画面のDM一覧を選択し
                        右上のアプローチDM新規作成を選択タイトル・送信先・本文 を入力してください。<br>
                        すぐに送らない場合は下書き保存をして配信する際に送信を選択して下さい。
                        </div>

                    </div>
                </div>
            </div>


            <!-- Item -->
            <div class="md_accordion-item">
                <div class="trigger-item js-toggle-on">
                    <p>アプローチDMでの配信をキャンセルできますか？</p>
                    <div class="background"></div>
                </div>
                <div class="hidden-item">
                    <div class="inner">

                        <!-- NestItem -->
                        <div class="nest-item">
                        アプローチDM作成後に送信（登録が完了しました）を行った場合のキャンセルする事が出来ません。<br>
                        ※挨拶メッセージのONとOFFは切り替え可能です。
                        </div>

                    </div>
                </div>
            </div>


<!-- 管理画面についてEND ------------------------------------>


        </div>
    </section>

    <!--::::::::::::::::::::::::::::::::::::::::::::::::::::::
        CTA
    :::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
    <section class="md_cta ">
        <div class="body">
            <h2 class="title">AUMAで新たな取引先を見つけてみませんか？</h2>
            <p>初期費用や月額料は一切かかりません。さっそくAUMAを利用しましょう！※</p>
            <div class="link">
                <div class="btn_link-wrap">
                    <a v-bind:href="route('registration.top')" class="btn_link"><span>無料でAUMAを試してみる</span></a>
                    <div class="bg-element"></div>
                </div>
            </div>
        </div>
        <p>※BASICプランへのアップグレードあり</p>
        <div class="background-image">
            <img src="/img/page-about/about-cta.jpg" alt="">
        </div>
    </section>

</div>
</template>

<style>
.faq .inner h3.heading {
    font-size:1.25rem;
    font-weight: 700;
	padding: 4rem 0 2rem;
    text-align: center;
}
.md_accordion-item .nest-item {
    counter-reset: number 0;
}
</style>

<script>
    import EndUserLayout from '@/Layouts/EndUserLayout'

    //ScrollTrigger
    import gsap from 'gsap';
    import { ScrollTrigger } from "gsap/ScrollTrigger";
    gsap.registerPlugin(ScrollTrigger);

    //Svg
    import SvgLogoAuma from '@/components/EndUser/svg/SvgLogoAuma'

    export default {
        layout: EndUserLayout,
        components: {
            SvgLogoAuma,
        },
        mounted() {
            ////////////////////////////////////
            //フローチャートの背景文字
            ////////////////////////////////////
            //固定 -----------------------------
            gsap.to("section.flowchart .bg-element-wrap", {
                scrollTrigger: {
                    trigger: "section.flowchart .bg-element-wrap",
                    start: "top 0%",
                    endTrigger: "section.plan-select",
                    end: "top 100%",
                    pin: true,
                    pinSpacing: false,
                },
            });
            gsap.fromTo("section.flowchart .bg-element span._top", {
                autoAlpha: 0,
                xPercent: -10,
            },
            {
                scrollTrigger: {
                    trigger: "section.flowchart",
                    start: "top 100%",
                    end: 'bottom 0%',
                    toggleActions: 'play play resume reverse',
                    scrub: 1,
                },
                autoAlpha: 1,
                xPercent: 0,
            });
            gsap.fromTo("section.flowchart .bg-element span._bottom", {
                autoAlpha: 0,
                xPercent: 10,
            },
            {
                scrollTrigger: {
                    trigger: "section.flowchart",
                    start: "top 100%",
                    end: 'bottom 0%',
                    toggleActions: 'play play resume reverse',
                    scrub: 1,
                },
                autoAlpha: 1,
                xPercent: 0,
            });

            ////////////////////////////////////
            //画像のパララックス
            ////////////////////////////////////
            gsap.to(".features .item-wrap._no1 .img-wrap img", {
                scrollTrigger: {
                    trigger: ".features .item-wrap._no1 .img-wrap img",
                    start: "top 100%",
                    end: 'bottom 0%',
                    toggleActions: 'play play resume reverse',
                    scrub: 0.5,
                },
                yPercent: -15, //transform の translateY(n%) と同一。
            });
            gsap.to(".features .item-wrap._no2 .img-wrap img", {
                scrollTrigger: {
                    trigger: ".features .item-wrap._no2 .img-wrap img",
                    start: "top 100%",
                    end: 'bottom 0%',
                    toggleActions: 'play play resume reverse',
                    scrub: 0.5,
                },
                yPercent: -15, //transform の translateY(n%) と同一。
            });
            gsap.to(".features .item-wrap._no3 .img-wrap img", {
                scrollTrigger: {
                    trigger: ".features .item-wrap._no3 .img-wrap img",
                    start: "top 100%",
                    end: 'bottom 0%',
                    toggleActions: 'play play resume reverse',
                    scrub: 0.5,
                },
                yPercent: -15, //transform の translateY(n%) と同一。
            });
            gsap.to(".features .item-wrap._no4 .img-wrap img", {
                scrollTrigger: {
                    trigger: ".features .item-wrap._no4 .img-wrap img",
                    start: "top 100%",
                    end: 'bottom 0%',
                    toggleActions: 'play play resume reverse',
                    scrub: 0.5,
                },
                yPercent: -15, //transform の translateY(n%) と同一。
            });

            ////////////////////////////////////
            //TimeLine
            ////////////////////////////////////
            gsap.fromTo(".md_timeline .progress-bar .bar", {
                scaleY: 0.08,
                ease: "none",
            },
            {
                scrollTrigger: {
                    trigger: ".md_timeline",
                    start: "top 80%",
                    end: 'bottom 45%',
                    toggleActions: 'play play resume reverse',
                    scrub: 0.2,
                },
                scaleY: 1,
            });

        }//mounted
    }
</script>